import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import GridColSettingConstants from "../Constants/GridColumn_SettingConstants";

let getGridColSetResult = [];
let getSaveGridSettingResult = [];
let getSavedFilterList = [];
let getSavedFilterValue = [];
let getSavedFilterOverDueOverViewValue = [];
let getSavedFilterInactiveValue = [];
let getSavedFilterNIOValue = [];
let getSavedFilterOrderOverViewValue = [];
let getEquListOnFilter = [];
let delSavesFilterResult = [];
let delSavesOverdueFilterResult = [];
let delSavesNioFilterResult = [];
let delSavesOrderOverviewFilterResult = [];
let delSavesInactiveFilterResult = [];
let saveGridOverDueSettingResult = [];
let saveGridNIOSettingResult = [];
let saveGridInactieSettingResult = [];
let saveGridOrderOverSettingResult = [];
let saveFilterListOverdueSettingResult = [];
let saveFilterListOrderOverViewSettingResult = [];
let saveFilterListInavtiveSettingResult = [];
let saveFilterListNIOSettingResult = [];
let getSavedOverDueFilterList = [];
let getSavedNIOFilterList = [];
let getSavedOrderViewFilterList = [];
let getSavedInactiveFilterList = [];
let getOverDueEquListOnFilter = [];
let getNIOEquListOnFilter = [];
let getOrderViewEquListOnFilter = [];
let getInactiveEquListOnFilter = [];
let getBulkUpdateSavedFilterValue = [];
let getMessageSavedFilterValue = [];
let saveFilterResult = [];
let saveFilterOverdueResult = [];
let saveFilterNIOResult = [];
let saveFilterOrderOverViewResult = [];
let saveFilterInactiveResult = [];
class GridColSettingStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }
  getGridColSetting() {
    return getGridColSetResult;
  }

  setGridColSetting(result) {
    getGridColSetResult = result;
  }
  getGridColSettingSaveResult() {
    return getSaveGridSettingResult;
  }

  setGridColSettingSaveResult(result) {
    getSaveGridSettingResult = result;
  }

  getSaveFilterResult() {
    return getSavedFilterList;
  }

  setSaveFilterResult(result) {
    getSavedFilterList = result;
  }

  getSavedFilterValueResult() {
    return getSavedFilterValue;
  }

  setSavedFilterValueResult(result) {
    getSavedFilterValue = result;
  }
  getEquListOnFilterResult() {
    return getEquListOnFilter;
  }

  setEquListOnFilterResult(result) {
    getEquListOnFilter = result;
  }
  getsaveFilDelResult() {
    return delSavesFilterResult;
  }

  setsaveFilDelResult(result) {
    delSavesFilterResult = result;
  }

  getsaveGridSettingOverDueResult() {
    return saveGridOverDueSettingResult;
  }

  setsaveGridSettingOverDueResult(result) {
    saveGridOverDueSettingResult = result;
  }

  getsaveGridSettingNIOResult() {
    return saveGridNIOSettingResult;
  }

  setsaveGridSettingNIOResult(result) {
    saveGridNIOSettingResult = result;
  }

  getsaveGridSettingInactiveResult() {
    return saveGridInactieSettingResult;
  }

  setsaveGridSettingInactiveResult(result) {
    saveGridInactieSettingResult = result;
  }

  getsaveGridSettingOrderOverviewResult() {
    return saveGridOrderOverSettingResult;
  }

  setsaveGridSettingOrderOverviewResult(result) {
    saveGridOrderOverSettingResult = result;
  }

  getsaveFilterListoverDueResult() {
    return saveFilterListOverdueSettingResult;
  }

  setsaveFilterListoverDueResult(result) {
    saveFilterListOverdueSettingResult = result;
  }
  getsaveFilterListorderOverViewResult() {
    return saveFilterListOrderOverViewSettingResult;
  }

  setsaveFilterListorderOverViewResult(result) {
    saveFilterListOrderOverViewSettingResult = result;
  }

  getsaveFilterListInactiveResult() {
    return saveFilterListInavtiveSettingResult;
  }

  setsaveFilterListInactiveResult(result) {
    saveFilterListInavtiveSettingResult = result;
  }

  getsaveFilterListNIOResult() {
    return saveFilterListNIOSettingResult;
  }

  setsaveFilternListNIOResult(result) {
    saveFilterListNIOSettingResult = result;
  }

  getSaveInactiveFilterResult() {
    return getSavedInactiveFilterList;
  }

  setSaveInactiveFilterResult(result) {
    getSavedInactiveFilterList = result;
  }

  getOverDueEquListOnFilterResult() {
    return getOverDueEquListOnFilter;
  }

  setOverDueEquListOnFilterResult(result) {
    getOverDueEquListOnFilter = result;
  }

  getNIOEquListOnFilterResult() {
    return getNIOEquListOnFilter;
  }

  setNIOEquListOnFilterResult(result) {
    getNIOEquListOnFilter = result;
  }

  getOrderViewEquListOnFilterResult() {
    return getOrderViewEquListOnFilter;
  }

  setOrderViewEquListOnFilterResult(result) {
    getOrderViewEquListOnFilter = result;
  }

  getInactiveEquListOnFilterResult() {
    return getInactiveEquListOnFilter;
  }

  setInactiveEquListOnFilterResult(result) {
    getInactiveEquListOnFilter = result;
  }

  getBulkUpdateSavedFilterValueResult() {
    return getBulkUpdateSavedFilterValue;
  }

  setBulkUpdateSavedFilterValueResult(result) {
    getBulkUpdateSavedFilterValue = result;
  }

  getMessageSavedFilterValueResult() {
    return getMessageSavedFilterValue;
  }

  setMessageSavedFilterValueResult(result) {
    getMessageSavedFilterValue = result;
  }

  getSavedFilterResult() {
    return saveFilterResult;
  }

  setSavedFilterResult(result) {
    saveFilterResult = result;
  }

  getSavedFilterOverDueResult() {
    return saveFilterOverdueResult;
  }

  setSavedFilterOverDueResult(result) {
    saveFilterOverdueResult = result;
  }
  getSavedFilterNIOResult() {
    return saveFilterNIOResult;
  }

  setSavedFilterNIOResult(result) {
    saveFilterNIOResult = result;
  }
  getSavedFilterOrderOverViewResult() {
    return saveFilterOrderOverViewResult;
  }

  setSavedFilterOrderOverViewResult(result) {
    saveFilterOrderOverViewResult = result;
  }

  getSavedFilterInactiveResult() {
    return saveFilterInactiveResult;
  }

  setSavedFilterInactiveResult(result) {
    saveFilterInactiveResult = result;
  }

  getSavedFilterValueOverDueOverResult() {
    return getSavedFilterOverDueOverViewValue;
  }

  setSavedFilterValueOverDueOverResult(result) {
    getSavedFilterOverDueOverViewValue = result;
  }

  getSavedFilterValueInactiveResult() {
    return getSavedFilterInactiveValue;
  }

  setSavedFilterValueInactiveResult(result) {
    getSavedFilterInactiveValue = result;
  }
  getSavedFilterValueNIOResult() {
    return getSavedFilterNIOValue;
  }

  setSavedFilterValueNIOResult(result) {
    getSavedFilterNIOValue = result;
  }

  getSavedFilterValueOrderOverViewResult() {
    return getSavedFilterOrderOverViewValue;
  }

  setSavedFilterValueOrderOverViewResult(result) {
    getSavedFilterOrderOverViewValue = result;
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case GridColSettingConstants.GET_COL_SETTING_SUCCESS:
        this.setGridColSetting(action.result);
        break;
      case GridColSettingConstants.GET_COL_SETTING_FAILURE:
        this.setGridColSetting(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_SUCCESS:
        this.setGridColSettingSaveResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_FAILURE:
        this.setGridColSettingSaveResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_SUCCESS:
        this.setSaveFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_FAILURE:
        this.setSaveFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_VALUE_SUCCESS:
        this.setSavedFilterValueResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_VALUE_FAILURE:
        this.setSavedFilterValueResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_VALUE_OVERDUE_OVER__SUCCESS:
        this.setSavedFilterValueOverDueOverResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_VALUE_OVERDUE_OVER_FAILURE:
        this.setSavedFilterValueOverDueOverResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_VALUE_SUCCESS:
        this.setSavedFilterValueInactiveResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_VALUE_FAILURE:
        this.setSavedFilterValueInactiveResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_NIO_SUCCESS:
        this.setSavedFilterValueNIOResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_NIO_FAILURE:
        this.setSavedFilterValueNIOResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_SUCCESS:
        this.setSavedFilterValueOrderOverViewResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_FAILURE:
        this.setSavedFilterValueOrderOverViewResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_FILTER_SUCCESS:
        this.setEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_FILTER_FAILURE:
        this.setEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_OVERDUE_SUCCESS:
        this.setsaveGridSettingOverDueResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_OVERDUE_FAILURE:
        this.setsaveGridSettingOverDueResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_NIO_SUCCESS:
        this.setsaveGridSettingNIOResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_NIO_FAILURE:
        this.setsaveGridSettingNIOResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_INACTIVE_SUCCESS:
        this.setsaveGridSettingInactiveResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_INACTIVE_FAILURE:
        this.setsaveGridSettingInactiveResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_ORDER_OVERVIEW_SUCCESS:
        this.setsaveGridSettingOrderOverviewResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_SETTING_ORDER_OVERVIEW_FAILURE:
        this.setsaveGridSettingOrderOverviewResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_OVERDUE_SUCCESS:
        this.setsaveFilterListoverDueResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_OVERDUE_FAILURE:
        this.setsaveFilterListoverDueResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_SUCCESS:
        this.setsaveFilterListorderOverViewResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_FAILURE:
        this.setsaveFilterListorderOverViewResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_INACTIVE_SUCCESS:
        this.setsaveFilterListInactiveResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_INACTIVE_FAILURE:
        this.setsaveFilterListInactiveResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_NIO_SUCCESS:
        this.setsaveFilternListNIOResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_LIST_NIO_FAILURE:
        this.setsaveFilternListNIOResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_SUCCESS:
        this.setSaveInactiveFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_FAILURE:
        this.setSaveInactiveFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_OVERDUE_SUCCESS:
        this.setOverDueEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_OVERDUE_FAILURE:
        this.setOverDueEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_NIO_SUCCESS:
        this.setNIOEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_NIO_FAILURE:
        this.setNIOEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_ORDER_OVERVIEW_SUCCESS:
        this.setOrderViewEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_ORDER_OVERVIEW_FAILURE:
        this.setOrderViewEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_INACTIVE_SUCCESS:
        this.setInactiveEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_EQUI_LIST_ON_INACTIVE_FAILURE:
        this.setInactiveEquListOnFilterResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_BULK_UPADTE_VALUE_SUCCESS:
        this.setBulkUpdateSavedFilterValueResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_BULK_UPADTE_VALUE_FAILURE:
        this.setBulkUpdateSavedFilterValueResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_MESSAGE_VALUE_SUCCESS:
        this.setMessageSavedFilterValueResult(action.result);
        break;
      case GridColSettingConstants.GET_SAVE_FILTER_MESSAGE_VALUE_FAILURE:
        this.setMessageSavedFilterValueResult(action.result);
        break;
      case GridColSettingConstants.DEL_SAVED_FILTER_SUCCESS:
        this.setsaveFilDelResult(action.result);
        break;
      case GridColSettingConstants.DEL_SAVED_FILTER__FAILURE:
        this.setsaveFilDelResult(action.result);
        break;

      case GridColSettingConstants.SAVE_GRID_FILTER_SUCCESS:
        this.setSavedFilterResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_FILTER_FAILURE:
        this.setSavedFilterResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_FILTER_OVERDUE_SUCCESS:
        this.setSavedFilterOverDueResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_FILTER_OVERDUE_FAILURE:
        this.setSavedFilterOverDueResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_FILTER_NIO_SUCCESS:
        this.setSavedFilterNIOResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_FILTER_NIO_FAILURE:
        this.setSavedFilterNIOResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_FILTER_ORDER_OVERVIEW_SUCCESS:
        this.setSavedFilterOrderOverViewResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_FILTER_ORDER_OVERVIEW_FAILURE:
        this.setSavedFilterOrderOverViewResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_FILTER_INACTIVE_SUCCESS:
        this.setSavedFilterInactiveResult(action.result);
        break;
      case GridColSettingConstants.SAVE_GRID_FILTER_INACTIVE_FAILURE:
        this.setSavedFilterInactiveResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const gridColSettingStore = new GridColSettingStore();
dispatcher.register(
  gridColSettingStore.handleCallback.bind(gridColSettingStore)
);
export default gridColSettingStore;
